import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

import { stepTypesStore } from '@stores/dictionaryStores/stepTypesStore';

export const columns: ColumnInterface[] = [
  {
    title: 'Технический номер шага',
    key: 'stepNum',
    width: 200,
  },
  {
    title: 'Внешний код шага',
    key: 'stepCodeExt',
    width: 200,
  },
  {
    title: 'Код контроля (ФНС)',
    key: 'codeFns',
    width: 200,
  },
  {
    title: 'Тип шага',
    key: 'stepType',
    width: 200,
    render: ({ value }) => stepTypesStore.stepTypes.find((type) => type.id === value)?.name,
  },
  {
    title: 'Наименование шага',
    key: 'stepName',
    width: 350,
  },
  {
    title: 'Описание шага',
    key: 'stepDesc',
    width: 350,
  },
  {
    title: 'Проверка применимости',
    key: 'premise',
    width: 350,
  },
  {
    title: 'Логика контроля',
    key: 'formula',
    width: 350,
  },
];
